export default {
  'app.member': 'Member permissions',
  'app.member.management': 'Member Management',
  'app.member.management.search': 'Search Filters',
  'app.member.management.invite': 'Invite Team Members',
  'app.member.management.invite.sso.tip':
    'The organization has enabled SSO login, and members who have not been granted roles will be automatically assigned the Default role. You can modify their roles after they join.',
  'app.member.management.invite.edit': 'Edit members',
  'app.member.management.invite.name.first': 'First Name',
  'app.member.management.invite.name.first.placeholder': `Enter the invitee's first name`,
  'app.member.management.invite.name.first.validate': `Please enter the invitee's first name`,
  'app.member.management.invite.name.last': 'Last Name',
  'app.member.management.invite.name.last.placeholder': `Enter the invitee's last name`,
  'app.member.management.invite.name.last.validate': `Please enter the invitee's last name`,
  'app.member.management.invite.email': 'Email Invite Member',
  'app.member.management.invite.email.placeholder': `Please enter the email, press Enter to add`,
  'app.member.management.invite.email.validate.empty': `Please enter the invitee's email`,
  'app.member.management.invite.email.validate.right': 'Please enter a valid email',
  'app.member.management.invite.ssoConfig': 'Organization SSO Service',
  'app.member.management.invite.ssoConfig.placeholder':
    'Select the SSO service of the organization',
  'app.member.management.invite.ssoConfig.validate':
    'Please select an SSO service of the organization',
  'app.member.management.invite.role': 'Role',
  'app.member.management.invite.role.placeholder':
    'Select a role in the organization. Send invitation',
  'app.member.management.invite.role.empty': 'No Role',
  'app.member.management.invite.role.create': 'To Add A Role',
  'app.member.management.invite.role.validate':
    'Please select a role in the organization. Send invitation',
  'app.member.management.invite.ok': 'Confirm',
  'app.member.management.invite.cancel': 'Cancel',
  'app.member.management.table.name': 'Account Name',
  'app.member.management.table.id': 'Account ID',
  'app.member.management.table.status': 'Account Status',
  'app.member.management.table.status.enable': 'Enable',
  'app.member.management.table.status.disable': 'Disable',
  'app.member.management.table.status.wait': 'Wait to join',
  'app.member.management.table.time.last': 'Last visit time',
  'app.member.management.table.time.create': 'Creation Time',
  'app.member.management.table.operation': 'Operation',
  'app.member.management.table.operation.detail': 'Detail',
  'app.member.management.table.operation.edit': 'Edit',
  'app.member.management.table.operation.resend': 'Resend',
  'app.member.management.table.operation.disable': 'Disable',
  'app.member.management.table.operation.enable': 'Enable',
  'app.member.management.table.operation.delete': 'Delete',
  'app.member.management.table.operation.delete.confirm': 'Account is not available after deletion',
  'app.member.management.table.operation.delete.confirm.ok': 'Confirm',
  'app.member.management.table.operation.delete.confirm.cancel': 'Cancel',
  'app.member.management.table.operation.invite.success': 'Invitation successful',
  'app.member.role': 'Role Management',
  'app.member.role.create': 'Create a role',
  'app.member.role.edit': 'Edit a role',
  'app.member.role.create.placeholder': `Enter the role name`,
  'app.member.role.admin': 'Administrator',
  'app.member.role.rights': 'Rights',
  'app.member.role.members': 'Members',
  'app.member.role.name.placeholder': 'Enter the role name',
  'app.member.role.creater': 'Created by',
  'app.member.role.creater.validate': 'Please input your username',
  'app.member.role.console': 'Console',
  'app.member.role.empty': 'Empty',
  'app.member.role.tip': 'Global roles are preset role of each project by default',
  'app.member.role.submit': 'Set successfully!',
  'app.member.role.save': 'Save successfully!',
  'app.member.role.delete':
    'After deleting the role, the member rights associated with the role will be invalidated',
  'app.member.role.delete.ok': 'Delete',
  'app.member.role.delete.cancel': 'Cancel',
  'app.member.role.members.table.search': 'Search Filters',
  'app.member.role.members.table.name': 'Account Name',
  'app.member.role.members.table.id': 'Account ID',
  'app.member.role.members.table.emial': 'Email',
  'app.member.role.members.table.status': 'Account Status',
  'app.member.role.members.table.status.enable': 'Enable',
  'app.member.role.members.table.status.disable': 'Disable',
  'app.member.role.members.table.status.wait': 'Wait to join',
  'app.member.role.members.table.time.last': 'Last visit time',
  'app.member.role.members.table.time.create': 'Creation Time',
  'app.member.role.members.table.operation': 'Operation',
  'app.member.role.members.table.operation.detail': 'Detail',
  'app.member.role.members.table.operation.detail.title': 'Member Detail',
  'app.member.role.members.table.operation.detail.permission': 'Permission Details',
  'app.member.role.members.table.operation.delete': 'Remove Role',
  'app.member.role.permission.sharing': 'All applications share role permissions',
  'app.member.role.permission.sharing.tip':
    'After checking and saving, the permissions possessed by this role remain consistent across all applications.',
  'app.member.management.create.org': 'Allow members to create organizations',
  'app.member.management.create.yes': 'Yes',
  'app.member.management.create.no': 'No',
  'app.member.roleCopy.copy': 'Copy Role',
  'app.member.roleCopy.title': 'Copy roles to other organizations',
  'app.member.roleCopy.select': 'Select Organization',
  'app.member.roleCopy.selectTip': 'Please select an organization',
  'app.member.roleCopy.all': 'Select All',
  'app.member.roleCopy.success': 'Successfully copied!',
  'app.member.role.otp.target.tip': `<p>1) When the target is a phone number:</p>
    <p>If the operator does not have permission to view the target, the number displayed in the history record will be a desensitized version. When the number is desensitized, only the first 3 digits and the last 2 digits of the number string are shown.</p>
    <p>2) When the target is an email address:</p>
    <p>The first 2 characters are displayed, and the email address remains unchanged from the "{'@'}" onwards.</p>
    <p>For example:</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>After desensitization, it is displayed as:</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
